import toast from 'react-hot-toast';
import { PromoItem } from '../types/Promo';
import { apiConfig } from 'core-lib/config/config';
import { postMethod } from "core-lib/utils/apiV2";
import { getDefaultHeaders } from 'core-lib/utils/network';

function serialize(data: any) {
  return data.map((el) => {
    const item: PromoItem = {
      code: el.code,
      id: el.id,
      description: el.description,
      subDescription: el.sub_description,
      tnc: el.terms_and_conditions,
      image: el.logo_image,
      tip: el.alert_message,
      tipColor: el.alert_message_text_color,
      toVerifyVrn: el?.meta_data?.vehicle_verification_bottom_sheet ?? false,
      applicable:el?.is_eligible,
      inEligibleImage:el?.ineligible_logo_image,
    };
    return item;
  });
}

const fetchPromoList = async (
  body: any
): Promise<{
  response?: PromoItem[];
  error?: any;
}> => {
  const headers = getDefaultHeaders({ deviceId: true, coords: true,effectivePlatform:true });
  const url = `${apiConfig(
    'promoNew',
    'v1'
  )}/promocodes`;
  const { response, error }: any = await postMethod({
    endPoint: url,
    body,
    headers,
    enableErrorHandling: true,
  });
  if (response) {
    if (response?.data) {
      return { response: serialize(response.data?.results ?? []) };
    } else return { error: {} };
  }
  if (error) {
    // toast.error('Unable to fetch promo list');
    return { error };
  }
};

export default fetchPromoList;
